import ChartsService from '@/services/benchmarks/ChartsService.js';
import { getBenchmarkId, SERIES_BY_MEDIA } from '@/utils';

import { chartsMutationTypes } from '../mutation-types';

export async function fetchInteractionsBySocialNetwork({ commit, rootState, rootGetters }) {
  try {
    commit(chartsMutationTypes.INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_LOADING, true);
    commit(chartsMutationTypes.INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_ERROR, false);

    const groupIdListJoined = rootGetters['ui/getterGroupIdList'].join(',');
    const channelListJoined = rootGetters['benchmarks/channelsLabels'].join(',');

    const { series, categories } = await ChartsService.getInteractionsBySocialNetwork({
      'benchmark-id': getBenchmarkId(),
      'group-id': groupIdListJoined,
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
      channel: channelListJoined,
    });

    if (!Array.isArray(series) && !Array.isArray(categories)) throw new Error();

    const seriesWithColor = series.map((serie) => ({
      ...serie,
      color: SERIES_BY_MEDIA.all[serie.name.toLowerCase()]?.color,
    }));

    const payload = {
      series: seriesWithColor.sort((a, b) => (a.name > b.name ? -1 : 1)),
      categories,
    };

    commit(chartsMutationTypes.INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_DATA, payload);
  } catch (e) {
    commit(chartsMutationTypes.INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_ERROR, true);
    console.error(e);
    return e;
  } finally {
    commit(chartsMutationTypes.INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_LOADING, false);
  }
}
